import { countryName, toA2 } from "@/features/landing/utils/country-name";

export function buildEsimAutoDetails({
  isEsim,
  detailsArray,
  durationDays,
  dataGB,
  dataUnlimited,
  dataSpeeds = [],
  country,
  roamingCount = 0,
  roamingCountries = [],
  regions = [],
}) {
  if (!isEsim || detailsArray) return null;

  const rows = [];

  const push = (label, value, icon) => {
    if (value != null && value !== "" && value !== false) {
      rows.push({ label, value, icon });
    }
  };

  if (Number(durationDays) > 0) push("Duration", `${durationDays} days`, "📅");
  if (dataUnlimited) push("Data", "Unlimited", "🌐");
  else if (Number(dataGB) > 0) push("Data", `${dataGB} GB`, "🌐");

  if (Array.isArray(dataSpeeds) && dataSpeeds.length) {
    push("Speeds", dataSpeeds.join(", "), "📶");
  }

  if (!country) {
    const n = Number(roamingCount) || 0;
    const region = Array.isArray(regions) && regions.length ? regions[0] : "Regional";

    if (Array.isArray(roamingCountries) && roamingCountries.length) {
      const names = roamingCountries
        .slice(0, 8)
        .map((c) => countryName(toA2(c)))
        .filter(Boolean);

      const more = roamingCountries.length - names.length;

      push(
        "Coverage",
        `${region}: ${names.join(", ")}${more > 0 ? ` +${more} more` : ""}`,
        "🧭"
      );
    } else if (n > 0) {
      push("Coverage", `${region} • ${n} countries`, "🧭");
    }
  }

  return rows.length ? rows : null;
}

export function buildVoucherAutoDetails({
  isVoucher,
  isVisa,
  detailsArray,
  isVisaAwards,
  isRange,
  priceMinDisplay,
  priceMaxDisplay,
  priceDisplay,
  priceCurrency,
  faceCurrency,
  country,
  regions = [],
}) {
  if (!isVoucher || !isVisa || detailsArray) return null;

  const rows = [];

  const push = (label, value, icon) => {
    if (value != null && value !== "" && value !== false) {
      rows.push({ label, value, icon });
    }
  };

  push("Variant", isVisaAwards ? "Visa Awards (6M)" : "Visa Prepaid", "🏷️");

  if (isRange && priceMinDisplay && priceMaxDisplay) {
    push("Denominations", `${priceMinDisplay} – ${priceMaxDisplay}`, "💵");
  } else if (priceDisplay) {
    push("Denomination", priceDisplay, "💵");
  }

  push("Currency", (priceCurrency || faceCurrency || "USD").toUpperCase(), "💱");
  push("Coverage", (isVisaAwards ? "Global" : country) || "—", "🌍");

  if (Array.isArray(regions) && regions.length) {
    push("Regions", regions.join(", "), "🗺️");
  }

  return rows.length ? rows : null;
}